module.exports = __webpack_public_path__ + "assets/img/txz.f0cfb6d1.png";